import { useMemo } from 'react';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import type { ShareChannel } from 'src/app/pages/psf/promoteOrShare/shared/types';
import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import { useGetShareContent } from './content';
import { useOnShareFailure } from './failure';
import { useOnShareSuccess } from './success';
import { useGetShareTrackingData } from './tracking';
import { useGetShareUrl } from './url';

export function useShareOptions({
	disableShortLinks,
}: {
	disableShortLinks: boolean;
}): ShareActionsOptions<ShareChannel> {
	const getUrl = useGetShareUrl();
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();
	const onSuccess = useOnShareSuccess();
	const onFailure = useOnShareFailure();
	const {
		data: {
			petition: { bestStoryShareVisual },
		},
	} = usePsfPromoteOrSharePageData();

	return useMemo(
		() => ({
			disableShortLinks,
			trackingEventName: 'share_petition',
			getUrl,
			getContent,
			getTrackingData,
			onSuccess,
			onFailure,
			config: {
				instagramStories: {
					enabled: !!bestStoryShareVisual,
				},
				tiktok: {
					enabled: !!bestStoryShareVisual,
				},
				facebook: { mode: { mobile: 'url', desktop: 'sdk' } }, // Disable Facebook SDK by default on mobile to avoid a bug with the share dialog. See https://change.atlassian.net/browse/CHANGE-75410
			},
		}),
		[getUrl, getContent, getTrackingData, onSuccess, onFailure, bestStoryShareVisual, disableShortLinks],
	);
}
